import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./exploreBucket.html";
class ExploreBucket extends LightningElement {
  constructor(...args) {
    super(...args);
    this.label = null;
    this.icon = void 0;
    this.selected = void 0;
    this.value = null;
  }
  handleBucketClick(event) {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent('bucketchange', {
      detail: {
        value: this.value
      },
      composed: true,
      bubbles: true,
      cancelable: true
    }));
  }
  handleAnalytics(event) {
    event.detail.button = {
      value: this.value,
      type: 'icon'
    };
    event.detail.gtm = 'ga4';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ExploreBucket, {
  publicProps: {
    label: {
      config: 0
    },
    icon: {
      config: 0
    },
    selected: {
      config: 0
    },
    value: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ExploreBucket, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;